import "./skill-gap-analysis.css";

// Short Report: Skill Gap Analysis
const SkillGapAnalysisReport = (comparisonResult) => {
  console.log("Comparison Result:", comparisonResult);
  // const comparisonResult = {
  //   summary: {
  //     entitiesCompared: 2,
  //     highPerformersCount: 15,
  //     leadershipReadyCount: 8,
  //   },
  //   metrics: [
  //     {
  //       name: "Avg. Performance of Team 1",
  //       type: "Product Development",
  //       performance: 70,
  //     },
  //     {
  //       name: "Avg. Performance of Team 2",
  //       type: "Product Management",
  //       performance: 80,
  //     },
  //   ],
  // }

  return (
    <div className="tt-sga-short-report-container">
      <div className="tt-sga-report-header">
        <h3>Soft Skills Gaps</h3>
        <p>Quick overview of skill gaps between the selected teams</p>
      </div>

      {/* Summary Cards */}
      <div className="tt-sga-comparison-summary">
        <div className="tt-sga-summary-card">
          <div className="tt-sga-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <div className="tt-sga-summary-content">
            <div className="tt-sga-summary-value">
              2{/* {comparisonResult?.comparisonData.summary?.totalEntities} */}
            </div>
            <div className="tt-sga-summary-label">Entities Compared</div>
          </div>
        </div>

        <div className="tt-sga-summary-card">
          <div className="tt-sga-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
              <path d="M4 22h16" />
              <path d="M10 14.66V17c0 .55.47.98.97 1.21C12.04 18.75 13 19.5 14 19.5s1.96-.75 3.03-1.29c.5-.23.97-.66.97-1.21v-2.34" />
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
            </svg>
          </div>
          <div className="tt-sga-summary-content">
            <div className="tt-sga-summary-value">
              {
                comparisonResult?.comparisonData?.softSkillGapsShortReport
                  ?.highPerformersCount
              }
            </div>
            <div className="tt-sga-summary-label">High Performers Count</div>
          </div>
        </div>

        <div className="tt-sga-summary-card">
          <div className="tt-sga-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M11.562 3.266a.5.5 0 0 1 .876 0L14.5 8.5l5.5.5a.5.5 0 0 1 .281.85L16 14l1 5.5a.5.5 0 0 1-.766.44L12 17l-4.234 2.94a.5.5 0 0 1-.766-.44L8 14l-4.281-4.15a.5.5 0 0 1 .281-.85L9.5 8.5l2.062-5.234Z" />
            </svg>
          </div>
          <div className="tt-sga-summary-content">
            <div className="tt-sga-summary-value">
              {
                comparisonResult?.comparisonData?.softSkillGapsShortReport
                  ?.totalLeadershipReadyCount
              }
            </div>
            <div className="tt-sga-summary-label">Leadership Ready Count</div>
          </div>
        </div>
      </div>

      {/* Metrics Comparison */}
      <div className="tt-sga-metrics-comparison">
        <h3>Avg. Performance Metrics</h3>
        <div className="tt-sga-metrics-chart">
          {comparisonResult?.comparisonData?.softSkillGapsShortReport?.avgPerformanceMetrics.map(
            (metrics, index) => {
              return (
                <div className="tt-sga-metric-bar-container" key={index}>
                  <div className="tt-sga-metric-info">
                    <span className="tt-sga-metric-name">{metrics.name}</span>
                  </div>
                  <div className="tt-sga-metric-bar">
                    <div
                      className="tt-sga-metric-fill"
                      style={{
                        width: `${Math.round(metrics?.avgPerformance)}%`,
                      }}
                    ></div>
                    <span className="tt-sga-metric-value">
                      {Math.round(metrics?.avgPerformance)}%
                    </span>
                  </div>
                </div>
              );
            }
          )}

          {/* ENTITY 1 */}

          {/* ENTITY 2 */}
          {/* <div className="tt-sga-metric-bar-container">
            <div className="tt-sga-metric-info">
              <span className="tt-sga-metric-name">
                {
                  comparisonResult?.comparisonData?.softSkillGapsShortReport
                    ?.teamBDetails?.teamName
                }
          
              </span>
    
            </div>
            <div className="tt-sga-metric-bar">
              <div
                className="tt-sga-metric-fill"
                style={{
                  width: `${Math.round(
                    comparisonResult?.comparisonData?.softSkillGapsShortReport
                      ?.teamBDetails?.avgPerformance
                  )}%`,
                }}
              ></div>
              <span className="tt-sga-metric-value">
                {Math.round(
                  comparisonResult?.comparisonData?.softSkillGapsShortReport
                    ?.teamBDetails?.avgPerformance
                )}
                %
              </span>
            </div>
          </div> */}
        </div>
      </div>

      {/* Analysis Overview */}
      <div className="tt-sga-insights-section">
        <h3>Analysis Overview</h3>
        <div className="tt-sga-analysis-paragraph">
          <p>
            {
              comparisonResult?.comparisonData?.softSkillGapsShortReport
                ?.overview
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default SkillGapAnalysisReport;
